import { action, computed, observable, runInAction } from 'mobx';
import { dispatch } from 'rfx-core';

import { service } from '#/shared/app';

import BaseStore from './_baseStore';

interface IShiftVisibility {
  createdAt: Date;
  modelName: string;
  updatedAt: Date;
  uuid: string;
}

export default class ShiftVisibilityStore extends BaseStore<IShiftVisibility> {
  constructor() {
    super({
      serviceName: 'work',
    });

    return this;
  }
  @observable
  loggedSteps = [];

  @action.bound
  async loadShiftVisibility(data) {
    try {
      const response = await service(this.serviceName).find({
        query: data,
      });
      console.log(1111, response);
      const loggedStepsResponse = response.loggedSteps ?? [];
      runInAction(() => {
        this.loggedSteps.replace(loggedStepsResponse);
      });
    } catch (err) {
      // Swallow Error and clear partnerPools in case of error
      this.log.error('Failed to load shift visibility', err, {
        extra: { data },
      });
      runInAction(() => {
        this.loggedSteps.clear();
      });
    }
    return this.loggedSteps;
  }
}
